module.exports = __webpack_public_path__ + "img/daggerSpray.b005527e.png";